// PlansPage.jsx
import React, { useEffect } from 'react';
//import { useNavigate } from 'react-router-dom';
import SavvytronHeader from '../components/SavvytronHeader';
import ConsultationCTA from '../components/ConsulatationCTA';

export default function PlansPage() {
  //const navigate = useNavigate();

  /* scroll to top on mount */
  useEffect(() => {
    window.scrollTo({ top: 0, behavior: 'smooth' });
  }, []);

  const basicFeatures = [
    'Mobile-friendly static website',
    'Responsive design for all devices',
    'SEO optimization (on-page & metadata)',
    'Free SSL certificate',
    'Custom domain setup',
    'Hosting & regular maintenance',
    'Quick turnaround and hands-off upkeep',
  ];

  const premiumFeatures = [
    'Fully dynamic website with backend',
    'Admin dashboard for content & user management',
    'Database-driven features (user accounts, product listings)',
    'Advanced analytics (conversion tracking, user behavior)',
    'Payment gateway integration (Stripe / PayPal)',
    'Blog / news module with easy publishing',
    'Newsletter signup & email marketing integration',
    'Ongoing support, maintenance, hosting & SEO',
    'Performance optimization (speed, security)',
    'Priority support & bug fixes',
    'Monthly content or feature updates',
  ];

  return (
    <div className="min-h-screen bg-gray-50 text-gray-800 p-4 sm:p-10 font-sans">
      <div className="max-w-4xl mx-auto bg-white rounded-2xl shadow-lg p-6 sm:p-10">

        <SavvytronHeader />

        {/* ===== Plans grid ===== */}
        <div className="relative grid grid-cols-1 md:grid-cols-2">
          {/* vertical divider on ≥ md */}
          <span className="hidden md:block absolute inset-y-0 left-1/2 w-px bg-gray-300" />

          {/* --- Basic plan --- */}
          <div className="p-6 max-w-md w-full">
            <h2 className="text-lg font-semibold mb-1">🔹 Basic Plan — $99/month</h2>
            <p className="text-sm text-gray-500 mb-4">One-time setup fee applies</p>

            <ul className="space-y-2 text-gray-700 mb-4">
              {basicFeatures.map((item, i) => (
                <li key={i} className="flex items-start gap-2">
                  <svg
                    className="w-5 h-5 mt-1 shrink-0 text-brand"
                    fill="none"
                    stroke="currentColor"
                    strokeWidth={2}
                    viewBox="0 0 24 24"
                  >
                    <path strokeLinecap="round" strokeLinejoin="round" d="M5 13l4 4L19 7" />
                  </svg>
                  <span>{item}</span>
                </li>
              ))}
            </ul>

            <p className="text-sm text-gray-600">
              Ideal for portfolios, landing pages, small business info sites, personal pages, and
              resumes.
            </p>
          </div>

          {/* --- Premium plan --- */}
          <div className="p-6 max-w-md w-full md:border-l md:border-gray-300">
            <h2 className="text-lg font-semibold mb-1">
              🔸 Premium Plan — Starting at $169/month
            </h2>
            <p className="text-sm text-gray-500 mb-4">One-time setup fee applies</p>

            <ul className="space-y-2 text-gray-700 mb-4">
              {premiumFeatures.map((item, i) => (
                <li key={i} className="flex items-start gap-2">
                  <svg
                    className="w-5 h-5 mt-1 shrink-0 text-brand"
                    fill="none"
                    stroke="currentColor"
                    strokeWidth={2}
                    viewBox="0 0 24 24"
                  >
                    <path strokeLinecap="round" strokeLinejoin="round" d="M5 13l4 4L19 7" />
                  </svg>
                  <span>{item}</span>
                </li>
              ))}
            </ul>

            <p className="text-sm text-gray-600">
              Ideal for e-commerce, booking systems, service platforms, membership sites, and
              mobile-responsive apps.
            </p>
          </div>
        </div>

        {/* call-to-action component */}
        <ConsultationCTA />
      </div>
    </div>
  );
}
